module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.completedItems.length) ? _c('MentoringRequestList', {
    attrs: {
      "items": _vm.completedItems
    }
  }) : _c('Warning', [_c('p', [_vm._v(_vm._s(_vm.warningText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4576d2fd","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/completedrequests/MentoringCompletedRequests.vue
// module id = 244af884f1cafc8e413e
// module chunks = 61